import React from "react";

export default function MlbDetailLoadingState({ error = "", onRetry }) {
  if (error) {
    return (
      <div data-testid="mlb-detail-error" style={{ minHeight: 560, padding: 24, display: "grid", alignContent: "start", gap: 14 }}>
        <div style={{ border: "1px solid #FCA5A5", background: "#FEF2F2", color: "#991B1B", borderRadius: 14, padding: 16, fontWeight: 900 }}>Detail temporarily unavailable</div>
        <button type="button" onClick={onRetry} style={{ justifySelf: "start", border: 0, borderRadius: 999, padding: "10px 16px", background: "#0B1A2A", color: "#fff", fontWeight: 900, cursor: "pointer" }}>Retry</button>
      </div>
    );
  }
  return (
    <div data-testid="mlb-detail-loading" aria-label="Loading indexed player detail" style={{ minHeight: 560, padding: 16, display: "grid", gap: 14 }}>
      {["Chart", "Quick Facts", "Context", "Last 5 / Last 10"].map((label, index) => (
        <section key={label} className={`pwg-detail-skeleton ${index === 0 ? "pwg-detail-skeleton-chart" : ""}`} style={{ animationDelay: `${(3 - index) * 90}ms`, minHeight: index === 0 ? 190 : 86 }}>
          <span>{label}</span><i /><i /><i />
        </section>
      ))}
    </div>
  );
}
